import { render, staticRenderFns } from "./SearchService.vue?vue&type=template&id=3b3b72b7&scoped=true&"
import script from "./SearchService.vue?vue&type=script&lang=js&"
export * from "./SearchService.vue?vue&type=script&lang=js&"
import style0 from "./SearchService.vue?vue&type=style&index=0&id=3b3b72b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3b72b7",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/service/SearchService.vue
// module id = null
// module chunks = 